import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import FiltroExportacao from "./components/ExportFilter";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useAuth } from "context/authContext";

function Exportar() {
  const { token } = useAuth();
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [open, setOpen] = useState(false);

  const handleShowAlert = (type, message) => {
    setAlert({ type, message });
    setOpen(true);
  };

  const onClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };

  const snackBar = (
    <Snackbar open={open} autoHideDuration={6000} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <MuiAlert onClose={onClose} severity={alert.type} sx={{ width: "100%" }}>
        {alert.message}
      </MuiAlert>
    </Snackbar>
  )

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <FiltroExportacao onAlert={handleShowAlert} token={token} />
      {snackBar}
      <Footer />
    </DashboardLayout>
  );
}

export default Exportar;